<template>
  <div class="chat-bubble" v-bind:class="[message.entity, {feedback: message.feedback}]" :id="message.id">
    <div class="bot-profilepic" v-if="message.entity === 'bot'">
      <i class="mm-icon favicon-mm-stitches">
        <svg role="presentation"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          class="icon"
          aria-hidden="true">
          <use href="#favicon-mm-stitches" />
        </svg>
      </i>
    </div>
    <template v-if="message.text && !this.showLogin">
      <div class="message">
        <p class="text">{{ this.removeTagsFromText(message.text) }}</p>
        <p class="subtext" v-if="message.subtext">{{ this.removeTagsFromText(message.subtext) }}</p>

        <template v-if="message.id === 0 && message.userNotLoggedIn && this.totalMessages === 1">
          <button type="button" @click="openLogin" class="mm-button mt-1 -block">
              {{ this.$translations.login.account.submit }}
          </button>
        </template>

        <template v-if="message.entity === 'bot' && message.supportLinks">
          <div class="support-links">
            <a v-for="supportLink in message.supportLinks" :href="supportLink" class="mm-button" target="_blank">{{ this.$translations.label.supportLink }}</a>
          </div>
        </template>

        <template v-if="message.entity === 'bot' && message.feedback">
          <div class="feedback-actions">
            <button type="button" class="feedback-emote mm-button"
              :class="{'selected': this.selectedFeedback === 0}"
              @click="sendFeedback(0)" :disabled="isFeedbackSelected">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 15C15 15 13.5 14 11 14C8.5 14 7 15 7 15M21 11C21 16.523 16.523 21 11 21C5.477 21 1 16.523 1 11C1 5.477 5.477 1 11 1C16.523 1 21 5.477 21 11Z" stroke="#1A1A1A" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16.3125 7.25C16.3125 7.33288 16.2796 7.41237 16.221 7.47097C16.1624 7.52958 16.0829 7.5625 16 7.5625C15.9171 7.5625 15.8376 7.52958 15.779 7.47097C15.7204 7.41237 15.6875 7.33288 15.6875 7.25C15.6875 7.16712 15.7204 7.08763 15.779 7.02903C15.8376 6.97042 15.9171 6.9375 16 6.9375C16.0829 6.9375 16.1624 6.97042 16.221 7.02903C16.2796 7.08763 16.3125 7.16712 16.3125 7.25ZM6.3125 7.25C6.3125 7.33288 6.27958 7.41237 6.22097 7.47097C6.16237 7.52958 6.08288 7.5625 6 7.5625C5.91712 7.5625 5.83763 7.52958 5.77903 7.47097C5.72042 7.41237 5.6875 7.33288 5.6875 7.25C5.6875 7.16712 5.72042 7.08763 5.77903 7.02903C5.83763 6.97042 5.91712 6.9375 6 6.9375C6.08288 6.9375 6.16237 6.97042 6.22097 7.02903C6.27958 7.08763 6.3125 7.16712 6.3125 7.25Z" fill="#1A1A1A" stroke="#1A1A1A" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>

            <button type="button" class="feedback-emote mm-button"
              :class="{'selected': this.selectedFeedback === 1}"
              @click="sendFeedback(1)" :disabled="isFeedbackSelected">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 15H15M21 11C21 16.523 16.523 21 11 21C5.477 21 1 16.523 1 11C1 5.477 5.477 1 11 1C16.523 1 21 5.477 21 11Z" stroke="#1A1A1A" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16.3125 7.25C16.3125 7.33288 16.2796 7.41237 16.221 7.47097C16.1624 7.52958 16.0829 7.5625 16 7.5625C15.9171 7.5625 15.8376 7.52958 15.779 7.47097C15.7204 7.41237 15.6875 7.33288 15.6875 7.25C15.6875 7.16712 15.7204 7.08763 15.779 7.02903C15.8376 6.97042 15.9171 6.9375 16 6.9375C16.0829 6.9375 16.1624 6.97042 16.221 7.02903C16.2796 7.08763 16.3125 7.16712 16.3125 7.25ZM6.3125 7.25C6.3125 7.33288 6.27958 7.41237 6.22097 7.47097C6.16237 7.52958 6.08288 7.5625 6 7.5625C5.91712 7.5625 5.83763 7.52958 5.77903 7.47097C5.72042 7.41237 5.6875 7.33288 5.6875 7.25C5.6875 7.16712 5.72042 7.08763 5.77903 7.02903C5.83763 6.97042 5.91712 6.9375 6 6.9375C6.08288 6.9375 6.16237 6.97042 6.22097 7.02903C6.27958 7.08763 6.3125 7.16712 6.3125 7.25Z" fill="#1A1A1A" stroke="#1A1A1A" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>

            <button type="button" class="feedback-emote mm-button"
              :class="{'selected': this.selectedFeedback === 2}"
              @click="sendFeedback(2)" :disabled="isFeedbackSelected">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 14C7 14 8.5 16 11 16C13.5 16 15 14 15 14M21 11C21 16.523 16.523 21 11 21C5.477 21 1 16.523 1 11C1 5.477 5.477 1 11 1C16.523 1 21 5.477 21 11Z" stroke="#1A1A1A" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16.3125 7.25C16.3125 7.33288 16.2796 7.41237 16.221 7.47097C16.1624 7.52958 16.0829 7.5625 16 7.5625C15.9171 7.5625 15.8376 7.52958 15.779 7.47097C15.7204 7.41237 15.6875 7.33288 15.6875 7.25C15.6875 7.16712 15.7204 7.08763 15.779 7.02903C15.8376 6.97042 15.9171 6.9375 16 6.9375C16.0829 6.9375 16.1624 6.97042 16.221 7.02903C16.2796 7.08763 16.3125 7.16712 16.3125 7.25ZM6.3125 7.25C6.3125 7.33288 6.27958 7.41237 6.22097 7.47097C6.16237 7.52958 6.08288 7.5625 6 7.5625C5.91712 7.5625 5.83763 7.52958 5.77903 7.47097C5.72042 7.41237 5.6875 7.33288 5.6875 7.25C5.6875 7.16712 5.72042 7.08763 5.77903 7.02903C5.83763 6.97042 5.91712 6.9375 6 6.9375C6.08288 6.9375 6.16237 6.97042 6.22097 7.02903C6.27958 7.08763 6.3125 7.16712 6.3125 7.25Z" fill="#1A1A1A" stroke="#1A1A1A" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </template>
      </div>
      <div class="message-delivered" v-if="message.entity === 'sender' && message.delivered">
        <span>{{this.$translations.label.delivered}}</span>
        <i class="mm-icon tick">
          <svg role="presentation"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            class="icon"
            aria-hidden="true">
            <use href="#tick" />
          </svg>
        </i>
      </div>
    </template>
    <template v-else-if="this.showLogin">
      <div class="message login-form">
        <login-form @login-done="loginDone" @close-login="closeLogin" @login-error="loginError"/>
      </div>
    </template>
    <template v-else>
      <div class="message loading">
        <div class="writing-loader">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import LoginForm from '../login-form/login-form.vue';

export default {
    data() {
      return {
        showLogin: false,
        selectedFeedback: null
      }
    },
    props: [
      'message',
      'totalMessages'
    ],
    emits: ['updateMessages', 'sendFeedback', 'setError', 'loginOpened'],
    components: {
      LoginForm
    },
    computed: {
      isFeedbackSelected() {
        return this.selectedFeedback !== null && this.selectedFeedback !== undefined;
      }
    },
    methods: {
      openLogin() {
        this.showLogin = true;
        this.$emit('loginOpened');
      },
      loginDone(loggedCustomer) {
        this.closeLogin();
        this.$emit('updateMessages', loggedCustomer);
      },
      loginError(errorMessage) {
        this.$emit('setError', errorMessage);
      },
      closeLogin() {
        this.showLogin = !this.showLogin;
      },
      sendFeedback(feedbackCode) {
        this.selectedFeedback = feedbackCode;
        this.$emit('sendFeedback', feedbackCode);
      },
      removeTagsFromText(str) {
        if ((str === null) || (str === '')){
          return '';
        }

        str = str.toString();
        // Regular expression to identify HTML tags in
        // the input string. Replacing the identified
        // HTML tag with a null string.
        return str.replace(/(<([^>]+)>)/ig, '');
      }
    },
    created() {
      if (this.message.feedbackValue) {
        this.selectedFeedback = this.message.feedbackValue;
      }
    }
}
</script>
